import { customRequest, handleResponse, accountId } from "src/helpers";
import { buildQueryString } from "src/utils/helpers";

const config = {
  apiUrl: process.env.VUE_APP_BACKEND_URL,
};

export const timeclockService = {
  getAll,
  getById,
  update,
  create,
  entryCreate,
  entryUpdate,
  createFromTask,
  delete: _delete,
  reportExportProdAnalytics,
  reportExportProdData,
  reportJsonProd,
  reportExportTimeclockAnalytics,
  reportExportTimeclockData,
  reportJsonTimeclock,
};

function getAll(params = {}) {
  params.excludeTimeClocks = true;
  
  const requestOptions = {
    ...customRequest("GET"),
  };

  let tagsArray = params.tagsArray ? [...params.tagsArray] : [];
  delete params.tagsArray;

  let queryString = buildQueryString(params);

  let tagParam = [];
  if (tagsArray && tagsArray.length > 0) {
    tagsArray.map((tag) => {
      tagParam.push(`tags=${tag}`);
    });
  }

  queryString += `&` + tagParam.join("&");

  let url = `${config.apiUrl}/Tasks?${queryString}`;

  return fetch(url, requestOptions)
    .then(handleResponse)
    .then((response) => {
      return response;
    });
}

function reportExportProdAnalytics(params = {}) {
  const requestOptions = {
    ...customRequest("POST"),
  };

  let { jobs, users, materials } = params;

  delete params.jobs;
  delete params.users;
  delete params.materials;
  let queryParams = buildQueryString(params);

  if (jobs && jobs.length > 0) {
    jobs.map((j) => {
      queryParams.append("jobs", j);
    });
  }

  if (users && users.length > 0) {
    users.map((u) => {
      queryParams.append("users", u);
    });
  }

  if(materials && materials.length > 0) {
    materials.map((m) => {
      queryParams.append("materials", m);
    });
  }

  const queryString = queryParams.toString();

  let url = `${config.apiUrl}/Reports/apex/production/export/analytics?${queryString}`;

  return fetch(url, requestOptions)
    .then((response) => {
      if (response.ok) {
        return response.text();
      } else {
        Promise.reject("error");
      }
    })
    .then((response) => {
      if (response) {
        let dataCsv = response;
        let data = "data:text/csv;charset=utf-8,";
        data += encodeURIComponent(dataCsv);
        const link = document.createElement("a");
        link.setAttribute("href", data);
        link.setAttribute("download", "apex-production-analytics.csv");
        link.click();
      } else {
        throw new Error("Error");
      }
    });
}

function reportExportProdData(params = {}) {
  const requestOptions = {
    ...customRequest("POST"),
  };

  let { jobs, users, materials } = params;

  delete params.jobs;
  delete params.users;
  delete params.materials;
  let queryParams = buildQueryString(params);

  if (jobs && jobs.length > 0) {
    jobs.map((j) => {
      queryParams.append("jobs", j);
    });
  }

  if (users && users.length > 0) {
    users.map((u) => {
      queryParams.append("users", u);
    });
  }

  if(materials && materials.length > 0) {
    materials.map((m) => {
      queryParams.append("materials", m);
    });
  }

  const queryString = queryParams.toString();

  let url = `${config.apiUrl}/Reports/apex/production/export/data?${queryString}`;

  return fetch(url, requestOptions)
    .then((response) => {
      if (response.ok) {
        return response.text();
      } else {
        Promise.reject("error");
      }
    })
    .then((response) => {
      if (response) {
        let dataCsv = response;
        let data = "data:text/csv;charset=utf-8,";
        data += encodeURIComponent(dataCsv);
        const link = document.createElement("a");
        link.setAttribute("href", data);
        link.setAttribute("download", "apex-production-data.csv");
        link.click();
      } else {
        throw new Error("Error");
      }
    });
}

function reportJsonProd(params = {}) {
  const requestOptions = {
    ...customRequest("POST"),
  };

  let { jobs, users, materials } = params;

  delete params.jobs;
  delete params.users;
  delete params.materials;
  let queryParams = buildQueryString(params);

  if (jobs && jobs.length > 0) {
    jobs.map((j) => {
      queryParams.append("jobs", j);
    });
  }

  if (users && users.length > 0) {
    users.map((u) => {
      queryParams.append("users", u);
    });
  }

  if(materials && materials.length > 0) {
    materials.map((m) => {
      queryParams.append("materials", m);
    });
  }

  const queryString = queryParams.toString();

  let url = `${config.apiUrl}/Reports/apex/production/json?${queryString}`;

  return fetch(url, requestOptions)
    .then(handleResponse)
    .then((response) => {
      return response;
    });
}

function reportExportTimeclockAnalytics(params = {}) {
  const requestOptions = {
    ...customRequest("POST"),
  };

  let { jobs, users } = params;

  delete params.jobs;
  delete params.users;
  let queryParams = buildQueryString(params);

  if (jobs && jobs.length > 0) {
    jobs.map((j) => {
      queryParams.append("jobs", j);
    });
  }

  if (users && users.length > 0) {
    users.map((u) => {
      queryParams.append("users", u);
    });
  }

  const queryString = queryParams.toString();

  let url = `${config.apiUrl}/Reports/apex/timeclock/export/analytics?${queryString}`;

  return fetch(url, requestOptions)
    .then((response) => {
      if (response.ok) {
        return response.text();
      } else {
        Promise.reject("error");
      }
    })
    .then((response) => {
      if (response) {
        let dataCsv = response;
        let data = "data:text/csv;charset=utf-8,";
        data += encodeURIComponent(dataCsv);
        const link = document.createElement("a");
        link.setAttribute("href", data);
        link.setAttribute("download", "apex-timeclock-analytics.csv");
        link.click();
      } else {
        throw new Error("Error");
      }
    });
}

function reportExportTimeclockData(params = {}) {
  const requestOptions = {
    ...customRequest("POST"),
  };

  let { jobs, users } = params;

  delete params.jobs;
  delete params.users;
  let queryParams = buildQueryString(params);

  if (jobs && jobs.length > 0) {
    jobs.map((j) => {
      queryParams.append("jobs", j);
    });
  }

  if (users && users.length > 0) {
    users.map((u) => {
      queryParams.append("users", u);
    });
  }

  const queryString = queryParams.toString();

  let url = `${config.apiUrl}/Reports/apex/timeclock/export/data?${queryString}`;

  return fetch(url, requestOptions)
    .then((response) => {
      if (response.ok) {
        return response.text();
      } else {
        Promise.reject("error");
      }
    })
    .then((response) => {
      if (response) {
        let dataCsv = response;
        let data = "data:text/csv;charset=utf-8,";
        data += encodeURIComponent(dataCsv);
        const link = document.createElement("a");
        link.setAttribute("href", data);
        link.setAttribute("download", "apex-timeclock-data.csv");
        link.click();
      } else {
        throw new Error("Error");
      }
    });
}

function reportJsonTimeclock(params = {}) {
  const requestOptions = {
    ...customRequest("POST"),
  };

  let { jobs, users } = params;

  delete params.jobs;
  delete params.users;
  let queryParams = buildQueryString(params);

  if (jobs && jobs.length > 0) {
    jobs.map((j) => {
      queryParams.append("jobs", j);
    });
  }

  if (users && users.length > 0) {
    users.map((u) => {
      queryParams.append("users", u);
    });
  }

  const queryString = queryParams.toString();

  let url = `${config.apiUrl}/Reports/apex/timeclock/json?${queryString}`;

  return fetch(url, requestOptions)
    .then(handleResponse)
    .then((response) => {
      return response;
    });
}

function getById(id) {
  const requestOptions = {
    ...customRequest("GET"),
  };

  return fetch(`${config.apiUrl}/Tasks/${id}`, requestOptions).then(
    handleResponse
  );
}

function entryCreate(payload) {
  payload.accountId = accountId();
  const requestOptions = {
    ...customRequest("POST", payload),
  };

  return fetch(`${config.apiUrl}/TimeClockEntries`, requestOptions)
    .then(handleResponse)
    .then((response) => {
      return {
        data: response,
      };
    });
}

function entryUpdate(payload) {
  payload.accountId = accountId();
  const requestOptions = {
    ...customRequest("PUT", payload),
  };

  return fetch(
    `${config.apiUrl}/TimeClockEntries/${payload.id}`,
    requestOptions
  )
    .then(handleResponse)
    .then((response) => {
      return {
        data: response,
      };
    });
}

function create(payload) {
  payload.accountId = accountId();
  const requestOptions = {
    ...customRequest("POST", payload),
  };

  return fetch(`${config.apiUrl}/Tasks`, requestOptions)
    .then(handleResponse)
    .then((response) => {
      return {
        data: response,
      };
    });
}

function createFromTask(payload) {
  payload.accountId = accountId();
  const requestOptions = {
    ...customRequest("POST", payload),
  };

  return fetch(
    `${config.apiUrl}/Tasks/${payload.id}/CreateTimeClock`,
    requestOptions
  )
    .then(handleResponse)
    .then((response) => {
      return {
        data: response,
      };
    });
}

function update(payload) {
  payload.accountId = accountId();
  payload.task["accountId"] = accountId();
  const requestOptions = {
    ...customRequest("PUT", payload),
  };

  return fetch(`${config.apiUrl}/Tasks/${payload.id}`, requestOptions)
    .then(handleResponse)
    .then((response) => {
      return {
        data: response,
      };
    });
}

function _delete(payload) {
  const requestOptions = {
    ...customRequest("DELETE"),
  };
  return fetch(`${config.apiUrl}/Tasks/${payload.id}`, requestOptions).then(
    handleResponse
  );
}
